
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.906 2.812H3.094a1.97 1.97 0 00-1.97 1.97v8.437a1.97 1.97 0 001.97 1.968h11.812a1.97 1.97 0 001.969-1.968V4.78a1.97 1.97 0 00-1.969-1.969zm-.498 3.257l-5.063 3.938a.563.563 0 01-.69 0L3.592 6.069a.562.562 0 11.69-.888L9 8.85l4.717-3.67a.563.563 0 01.69.889z","fill":"#4D4C4C"}})])
          )
        }
      }
    